import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Line } from '@app/shared/models/line.model';
import { Log } from 'ng2-logger';
import { Equipment } from '@app/shared/models/equipment.model';
import { EquipmentService } from '@app/core/services/equipment.service';
import { PermissionService } from '@app/authentication/services/permission.service';

import * as _ from 'lodash';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'app-line-equipment-form',
  templateUrl: './line-equipment-form.component.html',
  styleUrls: ['./line-equipment-form.component.scss']
})
export class LineEquipmentFormComponent implements OnInit {
  _logger = Log.create(LineEquipmentFormComponent.name);

  @Input() duplicate: boolean;
  @Input() showValidations = false;

  public line: Line;
  public equipmentForm: UntypedFormGroup;
  public availableEquipment: Equipment[] = [];

  constructor(private equipmentService: EquipmentService, private permissionService: PermissionService) { }

  ngOnInit() {
    this._logger.info("ngOnInit:: Preparing line equipment form");
    this.equipmentForm = new UntypedFormGroup({
      equipment: new UntypedFormControl([]),
    });

  }

  init(line: Line) {
    if (this.shouldRenderModifiers()) { this.getEquipments(); }
    if (line) {
      this.line = line;
      this.loadFormValue();
    }
  }

  private loadFormValue() {
    if (!this.line) {
      return;
    }
    const { equipment } = this.line;
    this.equipmentForm.setValue({ equipment });
  }

  resetForm() {
    this._logger.info("resetForm:: Resetting line equipment form", this.line);
    this.equipmentForm.reset();
  }

  getFormEquipments() {
    this._logger.info("getFormEquipments::", this.line);
    const formData = this.equipmentForm.getRawValue();
    return formData;
  }

  private getEquipments() {
    this._logger.info('getEquipments:: Retrieving list of not in use equipments');
    this.equipmentService.getAllEquipmentNotInUse().subscribe(
        (data: any) => {
            this._logger.info('getEquipments:: API returned data', data);
            this.availableEquipment = data.equipment || [];
        },
        (error: any) => {
            this._logger.error('getEquipments:: API returned error', error);
        }
    );
  }

  shouldRenderModifiers() {
    return this.permissionService.hasHasPermissionForFeature('MANAGE_LINES');
  }
}
